import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClientRefillsService } from 'src/app/services/apiclient/clientrefills/clientrefills.service';

declare var paypal:any;

@Component({
  selector: 'app-confirm-recharge',
  templateUrl: './confirm-recharge.component.html',
  styleUrls: ['./confirm-recharge.component.css']
})
export class ConfirmRechargeComponent implements OnInit {

  @ViewChild('paypal') paypalElement: ElementRef|any;

  amount: number;
  paymentType: string;
  card: any;
  innerHeight: number = window.innerHeight;
  currMerchant: any;
  loader: boolean|any;
  errorMessage: string|any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<ConfirmRechargeComponent>,
    private refillsApi: ClientRefillsService
  ) {
    this.amount = data.amount;
    this.card = data.card;
  
    this.paymentType = data.paymentType;
    this.currMerchant = data.currMerchant;
  }

  ngOnInit() {

    /**
     * Initialise Paypal
     */
    if (this.paymentType === "online_paypal") {
      setTimeout(() => {
        this.initPaypal();
      });
    }

  }

  /**
   * @description Crée une commande paypal
   * @returns {void}
   */
  createOrderPaypal(paypal_order_id?: string): Promise<any> {

    const that = this;

    that.loader = true;

    return new Promise((resolve, reject) => {

      that.refillsApi.creditCard(that.paymentType, that.amount, null, that.currMerchant.id_user, paypal_order_id).then((data) => {

        if (data.code === -3) {

          resolve(data.paypal_order);

        } else {

          that.errorMessage = data.message;
          that.loader = false;
          reject();

        }

      });

    });



  }

  /**
   * @description Initialise et configure stripe
   * @returns {void}
  */
  initPaypal(): void {

    const that = this;

    paypal.Buttons(
      {
        commit: true,
        style: {
          height: 40,
          layout: 'horizontal',
          tagline: false,
          size: 'responsive',
          color: 'gold',
          shape: 'rect',
          label: 'paypal',
        },

        createOrder: function (data:any, actions:any) {
          return that.createOrderPaypal().then(data => {
            return data;
          }).then(orderData => {
            return orderData.id
          })
        },
        onApprove: function (data:any, actions:any) {
          that.dialogRef.close(data.orderID);
        },

        onClick: () => {
          // Voir termes
        },

        onCancel: function (data:any, actions:any) {
          that.loader = false;
          // Show a cancel page or return to cart
        }

      }
    ).render(this.paypalElement.nativeElement);
  }

}
